module.exports = __webpack_public_path__ + "static/media/Logo_AgenteR.962498ed.svg";